import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NavigationService } from './services/NavigationService';
import { CheckoutService } from './services/CheckoutService';
import { CheckoutSettingsService } from './services/CheckoutSettingsService';
import { fetchTranslations } from '../utils/fetchTranslations';
import { withResultObserver } from '@wix/function-result-observation';
import { RESULT_PROP_NAME } from '../utils/consts';
import { ShippingError } from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import { cashierExpressAddressToEcomAddress } from '../utils/cashierExpressAddressToEcomAddress';
import { getShippingMethods } from '../utils/getShippingMethods';
import { getPaymentBreakdown } from '../utils/getPaymentBreakdown';
import { getPaymentAmount } from '../utils/getPaymentAmount';
import { confirmPayment } from '@wix/cashier-express-checkout-widget/dist/src/utils/confirmPayment';
import { shouldNavigateToFastFlowCheckout } from '../utils/shouldNavigateToFastFlow';
import { getOrderItemsFromCheckout } from '../utils/getOrderItemsFromCheckout';
import { BIService } from './services/BIService';
import { SPECS } from './SPECS';
export class ExpressCheckoutButtonsController {
  constructor(controllerParams) {
    _defineProperty(this, "controllerParams", void 0);
    _defineProperty(this, "navigationService", void 0);
    _defineProperty(this, "checkoutService", void 0);
    _defineProperty(this, "checkoutSettingsService", void 0);
    _defineProperty(this, "biService", void 0);
    _defineProperty(this, "controllerConfig", void 0);
    _defineProperty(this, "getCurrency", void 0);
    _defineProperty(this, "demoMode", void 0);
    _defineProperty(this, "translations", {});
    _defineProperty(this, "checkoutSettings", {});
    _defineProperty(this, "getCheckoutId", void 0);
    _defineProperty(this, "onCancel", void 0);
    _defineProperty(this, "onClick", void 0);
    _defineProperty(this, "onPaymentMethodsInit", void 0);
    _defineProperty(this, "checkoutId", '');
    _defineProperty(this, "cartId", '');
    _defineProperty(this, "latestTotalAmount", '0');
    _defineProperty(this, "onShippingContactSelected", async shippingContact => {
      try {
        var _updatedCheckout$ship;
        const {
          country,
          city,
          subdivision,
          zipCode: postalCode
        } = cashierExpressAddressToEcomAddress(shippingContact);
        const address = {
          country,
          city,
          postalCode,
          subdivision
        };
        const updatedCheckout = await this.checkoutService.updateCheckoutForShippingEstimation(this.checkoutId, address);
        this.latestTotalAmount = getPaymentAmount(updatedCheckout);
        const shippingMethods = getShippingMethods(updatedCheckout, this.translations);
        if (shippingMethods && (!((_updatedCheckout$ship = updatedCheckout.shippingInfo) != null && _updatedCheckout$ship.selectedCarrierServiceOption) || shippingMethods.length === 0)) {
          return {
            error: ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE
          };
        }
        return {
          shippingMethods,
          paymentBreakdown: getPaymentBreakdown(updatedCheckout, Boolean(this.checkoutSettings.taxOnProduct), this.controllerConfig.essentials.experiments.enabled(SPECS.ExpressCheckoutFixShippingWhenTaxIsIncluded)),
          paymentAmount: getPaymentAmount(updatedCheckout)
        };
      } catch (_unused) {
        return {
          error: ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE
        };
      }
    });
    _defineProperty(this, "onPaymentAuthorized", async (_ref, shouldUpdateShippingAddress) => {
      var _this$cartId;
      let {
        error,
        detailsId,
        shippingContact,
        billingContact
      } = _ref;
      if (error) {
        return {
          result: 'error'
        };
      }
      this.biService.clickContinueEWalletModalSf(this.checkoutId, (_this$cartId = this.cartId) != null ? _this$cartId : undefined);
      let updatedCheckout;
      try {
        updatedCheckout = await this.checkoutService.updateCheckoutByShippingAndBillingContacts(this.checkoutId, shouldUpdateShippingAddress, cashierExpressAddressToEcomAddress(shippingContact, billingContact), billingContact);
      } catch (_unused2) {
        return {
          result: 'error'
        };
      }
      if (await shouldNavigateToFastFlowCheckout({
        checkout: updatedCheckout,
        prevTotalAmount: this.latestTotalAmount,
        shouldUpdateShippingAddress,
        checkoutSettings: this.checkoutSettings
      })) {
        await this.navigationService.navigateToCheckout(updatedCheckout, detailsId);
      } else {
        const thankYouPageUrl = await this.navigationService.getThankYouPageUrlForPlaceOrder();
        const {
          orderId,
          paymentResponseToken
        } = await this.checkoutService.createOrderAndCharge({
          id: updatedCheckout.id,
          paymentToken: detailsId,
          urlParams: {
            errorUrl: await this.navigationService.getCheckoutErrorUrl(updatedCheckout, detailsId),
            cancelUrl: await this.navigationService.getCheckoutCancelUrl(updatedCheckout, detailsId),
            successUrl: thankYouPageUrl,
            pendingUrl: thankYouPageUrl
          }
        });
        if (!orderId) {
          return {
            result: 'error'
          };
        }
        if (this.controllerConfig.essentials.experiments.enabled(SPECS.UseCashierConfirmPaymentFn)) {
          var _this$controllerConfi, _this$controllerConfi2, _this$controllerConfi3, _this$controllerConfi4;
          await confirmPayment({
            chargeResponseToken: paymentResponseToken,
            meta: {
              appDefId: this.controllerConfig.appParams.appDefinitionId,
              msid: (_this$controllerConfi = this.controllerConfig.platformAPIs.bi) == null ? void 0 : _this$controllerConfi.metaSiteId,
              visitorId: (_this$controllerConfi2 = this.controllerConfig.platformAPIs) == null ? void 0 : (_this$controllerConfi3 = _this$controllerConfi2.bi) == null ? void 0 : _this$controllerConfi3.visitorId,
              widgetId: this.controllerParams.widgetId
            },
            biLoggerFactory: (_this$controllerConfi4 = this.controllerConfig.platformAPIs) == null ? void 0 : _this$controllerConfi4.biLoggerFactory,
            redirectFn: this.controllerConfig.wixCodeApi.location.to
          });
        }
        await this.navigationService.navigateToThankYouPage(orderId);
      }
      return {
        result: 'success'
      };
    });
    _defineProperty(this, "onShippingMethodSelected", async shippingMethod => {
      const updatedCheckout = await this.checkoutService.setShippingOption(this.checkoutId, shippingMethod.identifier);
      this.latestTotalAmount = getPaymentAmount(updatedCheckout);
      return {
        paymentAmount: getPaymentAmount(updatedCheckout),
        paymentBreakdown: getPaymentBreakdown(updatedCheckout, Boolean(this.checkoutSettings.taxOnProduct), this.controllerConfig.essentials.experiments.enabled(SPECS.ExpressCheckoutFixShippingWhenTaxIsIncluded))
      };
    });
    _defineProperty(this, "getInitialPaymentData", async () => {
      var _this$checkoutSetting;
      const checkoutId = await this.getCheckoutId();
      const checkout = await this.checkoutService.getCheckoutByCheckoutId(checkoutId);
      this.checkoutId = checkout.id;
      this.cartId = checkout.cartId;
      this.latestTotalAmount = getPaymentAmount(checkout);
      return {
        orderItems: getOrderItemsFromCheckout(checkout),
        paymentBreakdown: getPaymentBreakdown(checkout, Boolean((_this$checkoutSetting = this.checkoutSettings) == null ? void 0 : _this$checkoutSetting.taxOnProduct), this.controllerConfig.essentials.experiments.enabled(SPECS.ExpressCheckoutFixShippingWhenTaxIsIncluded)),
        paymentAmount: getPaymentAmount(checkout)
      };
    });
    _defineProperty(this, "onPaymentMethodsInitInner", numberOfButtons => this.onPaymentMethodsInit({
      numberOfButtons
    }));
    _defineProperty(this, "init", async () => {
      var _this$controllerConfi5, _this$controllerConfi6, _this$controllerConfi7, _this$controllerConfi8, _this$controllerConfi9, _this$checkoutSetting2;
      const locale = (_this$controllerConfi5 = this.controllerConfig.wixCodeApi) == null ? void 0 : (_this$controllerConfi6 = _this$controllerConfi5.window) == null ? void 0 : _this$controllerConfi6.locale.split('-')[0];
      [this.translations, this.checkoutSettings] = await Promise.all([fetchTranslations(locale), this.checkoutSettingsService.getSiteSettings()]);
      const domain = (_this$controllerConfi7 = this.controllerConfig.wixCodeApi) == null ? void 0 : (_this$controllerConfi8 = _this$controllerConfi7.location) == null ? void 0 : _this$controllerConfi8.baseUrl;
      const {
        appDefinitionId: appDefId,
        instanceId: appInstanceId,
        instance: appInstance
      } = this.controllerConfig.appParams || {};
      const {
        metaSiteId,
        visitorId,
        ownerId: siteOwnerId
      } = ((_this$controllerConfi9 = this.controllerConfig.platformAPIs) == null ? void 0 : _this$controllerConfi9.bi) || {};
      const meta = {
        appDefId,
        appInstanceId,
        siteId: metaSiteId,
        visitorId: visitorId,
        siteOwnerId,
        appInstance,
        consumerWidgetId: this.controllerParams.widgetId
      };
      const observe = withResultObserver(this.controllerConfig.setProps, {
        resultPropName: RESULT_PROP_NAME
      });
      const _expressCheckoutButtonsData = {
        currency: this.getCurrency(),
        locale,
        domain,
        meta,
        taxOnProduct: Boolean((_this$checkoutSetting2 = this.checkoutSettings) == null ? void 0 : _this$checkoutSetting2.taxOnProduct),
        translations: this.translations,
        demoMode: this.demoMode,
        onCancel: this.onCancel,
        onClick: this.onClick,
        ...observe({
          onShippingContactSelected: this.onShippingContactSelected,
          onPaymentAuthorized: this.onPaymentAuthorized,
          onShippingMethodSelected: this.onShippingMethodSelected,
          getInitialPaymentData: this.getInitialPaymentData,
          onPaymentMethodsInit: this.onPaymentMethodsInitInner
        })
      };
      this.controllerConfig.setProps({
        _expressCheckoutButtonsData
      });
    });
    const {
      controllerConfig,
      continueShoppingUrl,
      httpClient,
      getCurrency,
      getCheckoutId,
      demoMode,
      onCancel = () => {},
      onClick = () => {},
      onPaymentMethodsInit = () => {}
    } = controllerParams;
    this.controllerParams = controllerParams;
    this.navigationService = new NavigationService(controllerConfig, {
      experiments: controllerConfig.essentials.experiments,
      continueShoppingUrl
    });
    this.checkoutService = new CheckoutService(httpClient, controllerConfig, getCurrency);
    this.checkoutSettingsService = new CheckoutSettingsService(controllerConfig);
    this.biService = new BIService(controllerConfig);
    this.controllerConfig = controllerConfig;
    this.getCurrency = getCurrency;
    this.demoMode = !!demoMode;
    this.getCheckoutId = getCheckoutId;
    this.onCancel = onCancel;
    this.onClick = onClick;
    this.onPaymentMethodsInit = onPaymentMethodsInit;
  }
}
//# sourceMappingURL=ExpressCheckoutButtonsController.js.map